export default __webpack_public_path__ + "static/media/slider-hp-bottom-arrow.2060ebad.svg";